import React from "react";
// import "./styles/app.scss";
import Sidebar from "./components/layout/Sidebar";
import Header from "./components/layout/Header";
import DashboardOverview from "./features/dashboard/DashboardOverview";
import AppRoutes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useUser } from "./context/UserContext";
import ChatwootProvider from "./features/support/ChatwootProvider";
import { mapUserToChatwoot } from "./utils/userMapper";
import { identifyRybbit } from "./utils/rybbit";
import MaintenanceEntryButton from "./features/maintenance/shared/MaintenanceEntryButton";

function App() {
  const { user } = useUser();
  
  // Convert stored user info to Chatwoot format
  const chatwootUserDetails = React.useMemo(() => {
    if (!user) return null;
    return mapUserToChatwoot(user);
  }, [user]);

  // Attach the app's own user guid to Rybbit. The first identify on a device
  // also retroactively re-attributes that device's earlier anonymous events,
  // so pre-login pageviews land on the same user.
  React.useEffect(() => {
    identifyRybbit(user);
  }, [user]);

  React.useEffect(() => {
    // var window:any = window;
    var _mtm = ((window as any)._mtm = (window as any)._mtm || []);
    _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
    var d = document,
      g = d.createElement("script"),
      s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = "https://analytics.cms.chargingadda.com/js/container_x3sugyOh.js";
    (s as any).parentNode.insertBefore(g, s);
  }, []);
  return (
    <div className="app">
      {/* Above every overlay in the app. The highest z-index in src is 10000 and
          toastify defaults to 9999, so without this a toast raised from inside
          a drawer renders behind it -- which defeats the point of having one.
          autoClose is a default; useNotice gives errors longer to be read. */}
      <ToastContainer position="top-right" autoClose={3000} newestOnTop
                      style={{ zIndex: 100000 }} />
      <ChatwootProvider userDetails={chatwootUserDetails}>
        <AppRoutes />
        <MaintenanceEntryButton />
      </ChatwootProvider>
      
    </div>
  );
}

export default App;
